var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "both-pd-box" }, [
    _c(
      "div",
      {
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
      },
      [
        _c("h3", [_vm._v("公众号信息配置")]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c("div", { staticStyle: { color: "orange" } }, [
          _vm._v("注意：配置当前页前，需提前申请对应的微信公众号和开放平台"),
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "ruleForm11",
            staticClass: "demo-ruleForm",
            staticStyle: { width: "60%", "margin-top": "20px" },
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-width": "150px",
            },
          },
          [
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "公众号名称", prop: "wechatAppName" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.wechatAppName,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "wechatAppName", $$v)
                    },
                    expression: "ruleForm.wechatAppName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "公众号AppID", prop: "wechatAppId" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.wechatAppId,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "wechatAppId", $$v)
                    },
                    expression: "ruleForm.wechatAppId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "公众号AppSecret", prop: "wechatAppSecret" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.wechatAppSecret,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "wechatAppSecret", $$v)
                    },
                    expression: "ruleForm.wechatAppSecret",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "消息加解密密钥", prop: "aesKey" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.aesKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "aesKey", $$v)
                    },
                    expression: "ruleForm.aesKey",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "令牌(Token)", prop: "token" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.token,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "token", $$v)
                    },
                    expression: "ruleForm.token",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "服务器地址", prop: "serviceUrl" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.serviceUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "serviceUrl", $$v)
                    },
                    expression: "ruleForm.serviceUrl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "JS接口安全域名", prop: "domain" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.domain,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "domain", $$v)
                    },
                    expression: "ruleForm.domain",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "关注回复内容" },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    autosize: "",
                    placeholder: "请输入内容",
                  },
                  model: {
                    value: _vm.ruleForm.greetingContent,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "greetingContent", $$v)
                    },
                    expression: "ruleForm.greetingContent",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticStyle: { "margin-top": "60px" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "200px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm("ruleForm11")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }